import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'amfe-flexible'
// 完整引入 NutUI
import NutUI from '@nutui/nutui';
import '@nutui/nutui/dist/nutui.css';

import Vant from 'vant';
import { Toast } from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);
Vue.use(Toast);

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)

// 设置根 font-size，用于 rem 适配
function setHtmlFontSize() {
  const isMobile = /Android|webOS|iPhone|iPod|iPad|Mobile/i.test(navigator.userAgent);
  if (isMobile) {
    const baseSize = 75;
    const scale = document.documentElement.clientWidth / 750;
    document.documentElement.style.fontSize = baseSize * scale + 'px';
  } else {
    // PC 设置为 100px，相当于 rem=px，避免样式错乱
    document.documentElement.style.fontSize = '100px';
  }
}

setHtmlFontSize();
window.addEventListener('resize', setHtmlFontSize);

// 阻止双指缩放和双击放大
document.addEventListener('touchstart', function(event) {
  if (event.touches.length > 1) {
    event.preventDefault();  // 禁止双指缩放
  }
}, { passive: false });

document.addEventListener('dblclick', function(event) {
  event.preventDefault();  // 禁止双击放大
});
Vue.use(NutUI);

Vue.config.productionTip = false
router.beforeEach((to, from, next) => {
  // 如果路由中有 meta.title，则使用它设置页面 title
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  }
  next(); // 继续导航
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
